import { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { TimeRange } from '@kentik/ui-shared/query/query.types';

const TIME_PARAMS = ['lookback', 'start', 'end'] as const;

export function parseTimeFromSearch(search: string): TimeRange | undefined {
  const params = new URLSearchParams(search);
  const lookback = parseInt(params.get('lookback') ?? '');
  if (lookback) {
    return { lookback, start: 0, end: 0 };
  }
  const start = parseInt(params.get('start') ?? '');
  const end = parseInt(params.get('end') ?? '');
  return start < end ? { lookback: 0, start, end } : undefined;
}

export function buildSearchWithTime(search: string, { lookback, start, end }: TimeRange): string {
  const params = new URLSearchParams(search);
  TIME_PARAMS.forEach((k) => params.delete(k));
  if (lookback) {
    params.set('lookback', String(lookback));
  } else {
    params.set('start', String(start));
    params.set('end', String(end));
  }
  const str = params.toString();
  return str ? `?${str}` : '';
}

export function useBoardTimeUrlSync(time: TimeRange | undefined, enabled = true): void {
  const history = useHistory();
  const key = time ? `${time.lookback}|${time.start}|${time.end}` : '';
  const prevKeyRef = useRef(key);

  useEffect(() => {
    if (prevKeyRef.current === key) {
      return;
    }
    prevKeyRef.current = key;
    if (!enabled || !time) {
      return;
    }
    const search = buildSearchWithTime(history.location.search, time);
    if (search !== history.location.search) {
      history.replace({ ...history.location, search });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, enabled, history]);
}
